import { pushEvent } from '~/gtm/dataLayer';

/**
 * Push search event when user submits a search query
 * GA4 expects search_term parameter (snake_case)
 */
export function pushSearch(searchTerm: string): void {
  if (!searchTerm || searchTerm.trim().length === 0) return;

  pushEvent('search', {
    search_term: searchTerm.trim(),
  });
}
